import { render, staticRenderFns } from "./ContratacaoAnexosExcluir.vue?vue&type=template&id=7ec1a647"
import script from "./ContratacaoAnexosExcluir.vue?vue&type=script&lang=js"
export * from "./ContratacaoAnexosExcluir.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports